import { z } from 'zod';

import { zISODate, zMoneySigned, zOptionalString } from './common';

/**
 * Сверка кошелька с фактическим остатком.
 *
 * Любая ручная система рано или поздно расходится с реальностью: перевод
 * провели мимо сервиса, комиссию не заметили, операцию завели дважды. Важно
 * не то, что расхождение возникло, а то, что оно видно и чинится сразу —
 * а не ищется потом за три месяца по выпискам.
 */

export const reconcileWalletSchema = z.object({
  /** Что показывает банк или биржа прямо сейчас. */
  actualMinor: zMoneySigned,
  /**
   * Провести расхождение корректирующей операцией.
   *
   * По умолчанию нет: сначала человек смотрит на разницу и обычно вспоминает,
   * откуда она. Списывать её молча значит прятать ошибку, а не исправлять.
   */
  createCorrection: z.boolean().default(false),
  occurredAt: zISODate.optional(),
  /** Чем объясняется расхождение. Без этого через месяц никто не вспомнит. */
  note: zOptionalString(300),
});
export type ReconcileWalletInput = z.infer<typeof reconcileWalletSchema>;

export interface ReconciliationDto {
  id: string;
  walletId: string;
  actualMinor: number;
  expectedMinor: number;
  differenceMinor: number;
  transactionId: string | null;
  note: string | null;
  createdAt: string;
}

export interface ReconciliationCheck {
  walletId: string;
  walletName: string;
  currency: string;
  expectedMinor: number;
  /** Когда сходилось в последний раз. null — не сверяли ни разу. */
  lastReconciledAt: string | null;
}
